import { ApiProvider } from "./Provider";

const provider = ApiProvider();

export class ApiCore {
    constructor(options) {
        if(options.getAll){
            this.getAll = (config) => {
                return provider.getAll(options.url, config);
            }
        }

        if(options.getSingle){
            this.getSingle = (id) => {
                return provider.getSingle(options.url, id);
            }
        }

        if(options.post) {
            this.post = (model) => {
                return provider.post(options.url, model);
            }
        }

        if(options.put) {
            this.put = (model) => {
                return provider.put(options.url, model);
            }
        }

        if(options.patch) {
            this.patch = (model) => {
                return provider.put(options.url, model);
            }
        }

        if(options.getBy) {
            this.getBy = (target_id) => {
                return provider.getBy(options.byTarget, target_id, options.url)
            }
        }

        if(options.delete) {
            this.delete = (id) => {
                return provider.remove(options.url, id)
            }
        }

        if(options.extra){
            this.provider = provider.apiConnection;
        }

    }
}